import { z } from 'zod';

import { PriceIdEnum } from '@jane/bloom/types/schemas/roots/product';

export const TerpeneEnum = z.enum([
  'limonene',
  'nerolidol',
  'valencene',
  'caryophyllene',
  'caryophyllene oxide',
  'sabinene',
  'linalool',
  'geraniol',
  'geranyl acetate',
  'humulene',
  'myrcene',
  'pinene',
  'camphene',
  'camphor',
  'carene',
  'cedrene',
  'guaiol',
  'eucalyptol',
  'terpineol',
  'terpinolene',
  'phellandrene',
  'bisabolol',
  'borneol',
  'cymene',
  'fenchol',
  'menthol',
  'isoborneol',
  'isopulegol',
  'pulegone',
  'ocimene',
  'phytol',
]);

const _FlavorEnum = z.enum([
  'citrusy',
  'spicy',
  'floral',
  'hoppy',
  'earthy',
  'herbal',
]);

const _LabResultSchema = z.object({
  lab_results: z.array(
    z.object({
      compound_name: z.string(),
      unit: z.string(),
      unit_id: z.string(),
      value: z.number(),
    })
  ),
  price_id: PriceIdEnum,
});

const _LabResultWithTerpeneSchema = z.object({
  compound_name: z.string(),
  matchingTerpene: TerpeneEnum,
  unit: z.string(),
  unit_id: z.string(),
  value: z.number(),
});

export type LabResult = z.infer<typeof _LabResultSchema>;
export type LabResultWithTerpene = z.infer<typeof _LabResultWithTerpeneSchema>;
export type Terpene = z.infer<typeof TerpeneEnum>;
export type Flavor = z.infer<typeof _FlavorEnum>;
